import { useEffect, useMemo } from 'react';

import { useQuery } from 'components/hooks/useQuery';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  resetTalentPlanningSidepanelState,
  setIsTalentPlanningSidepanelOpen,
} from 'reducers/talentPlanningSidepanelSlice';

const useCalibrationViewPanelQueryParams = () => {
  const { showCalibrationViewPanel, cVPanelEmpId, cVPanelCalibrationViewId } = useQuery();
  return { showCalibrationViewPanel, cVPanelEmpId, cVPanelCalibrationViewId };
};

const useCalibrationViewSidepanelLinkState = () => {
  const dispatch = useDispatch();
  // const history = useHistory();
  // const { location } = history;
  // const queryString = location.search;
  // const previousQueryString = usePrevious(queryString);
  const { showCalibrationViewPanel, cVPanelEmpId, cVPanelCalibrationViewId } = useCalibrationViewPanelQueryParams();

  useEffect(() => {
    // if (queryString === previousQueryString) return;

    if (showCalibrationViewPanel === 'true' && cVPanelEmpId && cVPanelCalibrationViewId) {
      dispatch(setIsTalentPlanningSidepanelOpen(true));
    } else dispatch(resetTalentPlanningSidepanelState());
  }, [dispatch, showCalibrationViewPanel, cVPanelEmpId, cVPanelCalibrationViewId]);
};

const useOpenCalibrationViewSidepanel = () => {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;
  const queryParams = useQuery();

  const memoizedReturnVal = useMemo(() => {
    const openCalibrationSidepanel = ({ cVPanelCalibrationViewId, cVPanelEmpId }) => {
      const searchQuery = queryString.stringify({
        ...queryParams,
        showCalibrationViewPanel: true,
        cVPanelEmpId,
        cVPanelCalibrationViewId,
      });
      history.push({
        pathname,
        search: searchQuery,
      });
    };

    return { openCalibrationSidepanel };
  }, [history, pathname, queryParams]);

  return memoizedReturnVal;
};

const useCloseCalibrationSidepanel = () => {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { showCalibrationViewPanel, cVPanelEmpId, cVPanelCalibrationViewId, ...rest } = useQuery();

  const memoizedReturnVal = useMemo(() => {
    const closeCalibrationSidepanel = () => {
      const searchQuery = queryString.stringify(rest);
      history.push({
        pathname,
        search: searchQuery,
      });
    };

    return { closeCalibrationSidepanel };
  }, [history, pathname, rest]);

  return memoizedReturnVal;
};

export {
  useCalibrationViewSidepanelLinkState,
  useCalibrationViewPanelQueryParams,
  useOpenCalibrationViewSidepanel,
  useCloseCalibrationSidepanel,
};
